import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgComponent } from '@nx-massaud/media/ui/svg';
import { MediaImageComponent } from '@nx-massaud/media/ui/image';
import { RouterModule } from '@angular/router';
import { PushPipe } from '@ngrx/component';
import { SvgIconComponent } from '@nx-massaud/ui/svg-icon';
import { TranslocoService } from '@ngneat/transloco';
import { GridListItem } from '@madeinlune/massaud-types';

@Component({
  selector: 'msd-ui-grid-list-item',
  standalone: true,
  imports: [
    CommonModule,
    SvgComponent,
    MediaImageComponent,
    RouterModule,
    PushPipe,
    SvgIconComponent,
  ],
  template: `
    <ng-container *ngIf="data">
      <a [routerLink]="data.path">
        <div
          class="b-texts"
          [style.background-color]="data.backgroundColor"
          [class.is-dark]="data.isDarkBackground"
        >
          <h2 [innerHTML]="data.title" class="title"></h2>
          <ng-container *ngIf="data.date">
            <span
              [innerHTML]="
                data.date | date : 'd MMMM y' : '' : (lang$ | ngrxPush)
              "
              class="date"
            ></span>
          </ng-container>
        </div>
        <div class="b-media">
          <ng-container *ngIf="data.thumb?.type === 'svgs'">
            <nx-massaud-svg [media]="$any(data.thumb)"></nx-massaud-svg>
          </ng-container>
          <ng-container *ngIf="data.thumb?.type === 'images'">
            <i2l-media-image [image]="$any(data.thumb)"></i2l-media-image>
            <ng-container *ngIf="data.playable">
              <div class="b-play-icon">
                <msd-ui-svg-icon
                  class="play-icon big"
                  [icon]="'play'"
                ></msd-ui-svg-icon>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </a>
    </ng-container>
  `,
  styleUrls: ['./grid-list-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridListItemComponent {
  protected translocoService = inject(TranslocoService);

  readonly lang$ = this.translocoService.langChanges$;

  @Input()
  data: GridListItem | undefined;
}
